import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'mapStateTypes',
  initialState: {
    mapCompState : "HOME"
  },
  reducers: {
    addState(state, action) {
      state.mapCompState = action.payload;
    },
  },
});

export { actions as mapStateTypesActions };
export { reducer as mapStateTypesReducer };